"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapKeyboard = void 0;
const mapHelpers_1 = require("../map/mapHelpers");
function mapKeyboard(container, map, markersInLayers, zoomMarker) {
    var _a;
    let markers = null;
    let currentMarker = 0;
    const attributions = container.querySelector('.leaflet-control-attribution');
    (_a = attributions === null || attributions === void 0 ? void 0 : attributions.querySelectorAll('a')) === null || _a === void 0 ? void 0 : _a.forEach(attribution => {
        attribution.setAttribute('tabindex', '-1');
    });
    map.addEventListener('keydown', (e) => {
        const event = e.originalEvent;
        switch (event.key) {
            case 'ArrowDown':
            case 'ArrowLeft':
                markers = (0, mapHelpers_1.getMarkersFromLayers)(markersInLayers);
                event.preventDefault();
                currentMarker = (currentMarker - 1 + markers.length) % markers.length;
                zoomMarker.zoom(markers[currentMarker]);
                break;
            case 'ArrowUp':
            case 'ArrowRight':
                markers = (0, mapHelpers_1.getMarkersFromLayers)(markersInLayers);
                event.preventDefault();
                currentMarker = (currentMarker + 1) % markers.length;
                zoomMarker.zoom(markers[currentMarker]);
                break;
            case '+':
                map.zoomIn();
                break;
            case '-':
                map.zoomOut();
                break;
        }
    });
}
exports.mapKeyboard = mapKeyboard;
